jQuery_T4NT(document).ready(function ($) {
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + window.innerHeight; // <-- here

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  var startedNumberAimation = 0;
  $(window).scroll(function () {
    if ($('.count').isInViewport()) {
      startedNumberAimation += 1;
    }
    if (startedNumberAimation == 1) {
      $('.count').each(function () {
        $(this).prop('Counter', 0).animate({
          Counter: $(this).text()
        }, {
          duration: 4 * 1000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now).toLocaleString('en'));
          }
        });
      });
    }
  });
});



// Boolland: Triggered when cart is changed/updated.
$(document).ready(function () {
  (function (ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function () {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if ([
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          `${window.location.origin}/cart/clear.js`,
        ].includes(res.url)) {
          res.clone().json().then(data => {
            var cartItems = data.items;
            var refresh = false;
            const epp_max_item = 2;
            
            const totalCartQuantity = cartItems.reduce((sum, item) => {
              const excludedTypes = ["Engraving Service", "Gift Message", "Extra Packaging Protection"];
              return excludedTypes.includes(item.product_type) ? sum : sum + item.quantity;
            }, 0);

            const eppLabel = document.getElementById('eppLabel');
            const lowPrice = eppLabel.dataset.eppPriceLow;
            const highPrice = eppLabel.dataset.eppPriceHigh;
            const newPrice = totalCartQuantity > epp_max_item ? highPrice : lowPrice;
            eppLabel.innerText = `Add ${newPrice} for Extra Packaging Protection`;
            
            cartItems.forEach(function (item) {
              if (item.product_type == "Engraving Service") {
                var removeItem = true;
                var engravingID = item.properties['EngravingID'];
                
                for (var i = 0; i < cartItems.length; i++) {
                  var otherItem = cartItems[i];
                  if (otherItem.product_type != "Engraving Service" && otherItem.properties['EngravingID'] == engravingID) {
                    removeItem = false;
                    break;
                  }
                }
                if (cartItems.length <= 1) {
                  removeItem = true;
                }
                // Remove From Cart
                if (removeItem) {
                  $.post("/cart/change.js", {
                    'id': item.key,
                    'quantity': 0
                  }).then(function (res) {
                    window.location.reload();
                  });
                }
              }
              if (item.product_type == "Gift Message") {
                var removeGiftItem = true;
                var giftMsgID = item.properties['GiftMessageID'];
                for (var x = 0; x < cartItems.length; x++) {
                  var otherCartItem = cartItems[x];
                  if (otherCartItem.product_type != "Gift Message" && otherCartItem.properties['GiftMessageID'] == giftMsgID) {
                    removeGiftItem = false;
                    break;
                  }
                }
                if (cartItems.length <= 1) {
                  removeGiftItem = true;
                }
                // Remove From Cart
                if (removeGiftItem) {
                  $.post("/cart/change.js", {
                    'id': item.key,
                    'quantity': 0
                  }).then(function (res) {
                    window.location.reload();
                  });
                }
              }
              if (item.product_type != "Engraving Service" && item.properties.EngravingID != null && item.properties.EngravingID !== "") {
                var removeMainProduct = true;
                var engravingID = item.properties['EngravingID'];
                
                for (var z = 0; z < cartItems.length; z++) {
                  var otherItem = cartItems[z];
                  if (otherItem.product_type == "Engraving Service" && otherItem.properties['EngravingID'] == engravingID) {
                    removeMainProduct = false;
                    break;
                  }
                  if (cartItems.length <= 1) {
                    removeItem = true;
                  }
                  // Remove From Cart
                  if (removeItem) {
                    $.post("/cart/change.js", {
                      'id': item.key,
                      'quantity': 0
                    }).then(function (res) {
                      window.location.reload();
                    });
                  }                  
                }
              }
              // For Bundle Box Gift Card
              if (item.properties._bundle_box != null && item.properties._bundle_box !== "") {
                var remove_bundle_item = true;
                var curr_quantity = item.quantity;
                var min_qty = 2;
                
                if (item.product_id == "8642193391938") {
                  min_qty = 3;
                }
                
                for (var i = 0; i < cartItems.length; i++) {
                  var otherCartItem = cartItems[i];
                  if (item.variant_id == otherCartItem.variant_id) {
                    continue;
                  } else if (item.properties._bundle_box == otherCartItem.properties._bundle_box) {
                    curr_quantity += otherCartItem.quantity;
                  }
                  
                  if (curr_quantity >= min_qty) {
                    remove_bundle_item = false;
                  }
                }

                if (remove_bundle_item) {
                  $.post("/cart/change.js", {
                    'id': item.key,
                    'quantity': 0
                  }).then(function (res) {
                    $.post("/cart/add.js", {
                      'id': item.variant_id,
                      'quantity': item.quantity
                    }).then(function (res) {
                      refresh = true;
                      window.location.reload();
                    });
                  });
                  refresh = true;
                }
              }
              if (item.product_type == "Extra Packaging Protection") {
                const epp_max_item = 2;
                var ccount_exclude = 0;
                
                for (var i = 0; i < cartItems.length; i++) {
                  var otherItem = cartItems[i];
                  if (
                    otherItem.product_type !== "Engraving Service" &&
                    otherItem.product_type !== "Gift Message" &&
                    otherItem.product_type !== "Extra Packaging Protection"
                  ) {
                    ccount_exclude += otherItem.quantity;
                  }
                }

                if (ccount_exclude > epp_max_item && item.variant_id != '50504752791874') {
                  $.post("/cart/change.js", {
                    'id': item.key,
                    'quantity': 0
                  }).then(function (res) {
                    $.post("/cart/add.js", {
                      'id': 50504752791874,
                      'quantity': 1
                    }).then(function (res) {
                      window.location.reload();
                    });
                  });
                } else if (ccount_exclude <= epp_max_item && item.variant_id != '50494196711746') {
                  $.post("/cart/change.js", {
                    'id': item.key,
                    'quantity': 0
                  }).then(function (res) {
                    $.post("/cart/add.js", {
                      'id': 50494196711746,
                      'quantity': 1
                    }).then(function (res) {
                      window.location.reload();
                    });
                  });
                }
              }
            });
          });
        }
      });
      return response;
    }
  }(window, window.fetch))
});

// Boolland Custom Function
$(document).ready(function() {
  // Tab Message Functionbl_custom_tab_code();// Boolland: Engraving Button - Show or Hide depends on current selected variant
  $(".t4s-swatch__list").on("click", "[data-swatch-item]", function () {
    let $currentSelected = $(".t4s-swatch__item.is--selected"); // Find currently selected variant
    let $newSelected = $(this); // New selected variant

    if (!$newSelected.hasClass("is--selected")) {
      let variantId = $newSelected.attr("data-variant-id");
      let engraving = $newSelected.attr("data-engraving") === "true";
      var engravingButton = $("#blEngravingBtn");

      if (engraving) {
          engravingButton.css("display", "flex");
      } else {
          engravingButton.css("display", "none");
      }

      $('#engravingVariantIDKeeper').html('');
      $('#engravingVariantIDKeeper').html(variantId);
    }
  });
});

function bl_custom_tab_code() {
  var original_title = document.title;
  var message1 = "Over Your Ex, Not Us!";
  var message2 = "❤️ Reconnect Here";
  var switchInterval;

  $(document).on('visibilitychange', function() {
    if (document.hidden) {
      if (message1 != '' && message2 != '') {
        document.title = message1;
        switchInterval = setInterval(switchMessages, 3000);

        function switchMessages() {
          document.title = (document.title === message1) ? message2 : message1;
        }
        
      } else if (message1 != '') {
        document.title = message1;
      } else if (message2 != '') {
        document.title = message2;
      }
    } else {
      document.title = original_title;
      clearInterval(switchInterval);
    }
  });
}

jQuery_T4NT(document).ready(function($) {
  // set the info height to the media height
  const mediaWrapper = $('.t4s-product__media-wrapper')[0];
  const infoScrollable = $('.t4s-product__info-wrapper.bl-scrollable');
  infoScrollable.css('--bl-scroll-height', `${mediaWrapper.offsetHeight}px`);

  function updateShadow() {
    if (infoScrollable[0].scrollTop + infoScrollable[0].clientHeight < infoScrollable[0].scrollHeight) {
      infoScrollable.css('--bl-shadow-height', `${infoScrollable[0].scrollTop + mediaWrapper.offsetHeight}px`);
      infoScrollable.css('--bl-shadow-toggle', 'block');      
    } else if (infoScrollable[0].scrollTop + infoScrollable[0].clientHeight == infoScrollable[0].scrollHeight) {
      infoScrollable.css('--bl-shadow-toggle', 'none');      
    }
  }
  infoScrollable.on('scroll', updateShadow);
  updateShadow();
  
  $( document ).on( "variant:changed", function( evt ) {
    // price division - By Cyrus
    const price_per_day = evt.currentVariant.price / $('.bl-product-price-division__wrapper span').data('price-division') / 100;
    $('.bl-product-price-division__wrapper span').html('RM' + price_per_day.toFixed(2) + ' a day');

    // hide default incoming message if current variant have stock
    var inventoryQuantity = evt.currentVariant.inventory_quantity;
    var incoming = evt.currentVariant.incoming;
    if (!(inventoryQuantity > 0) && !incoming) {
      $('.t4s-incoming__mess[data-default_incoming__mess]').show();
    } else {
      $('.t4s-incoming__mess[data-default_incoming__mess]').hide();
    }
  });
});
